import styled from "styled-components";
import { theme } from "../theme";

export const StyledFooter = styled.footer`
	width: 100%;
	max-width: 33rem;
	margin-top: 2.5rem;
	font-family: ${theme.font.secondary};
	font-size: 1.2rem;
`;
